import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/scrollToTop";
import ErrorBoundary from "components/errorBoundary";
import NotFound from "pages/notFound";
import AdminDashboard from './pages/admin-dashboard';
import ResetPasswordPage from './pages/reset-password';
import LoginPage from './pages/login';
import ForgotPassword from './pages/forgot-password';
import EmployeeDashboard from './pages/employee-dashboard';
import EmployeeManagement from './pages/employee-management';
import AttendanceRecords from "pages/attendance-records";
import StrangerDetection from "pages/stranger-detection";
import EmployeeProfile from "pages/employee-profile";
// import CameraManagement from "pages/camera-management/camera";
import { ProtectedRoute } from "components/ui/navigationGuard";
import LeaveManagement from "pages/leave-management";
import LeaveSettings from "pages/leave-settings";
import SettingsMnagement from "pages/camera-management";
import { Toaster } from "react-hot-toast";
import SalaryManagement from "pages/salary-management";
import DepartmentManagement from "pages/department-management";
import RoleManagement from "pages/role-management";
import AdminManagement from "pages/admin-management";
import Settings from "pages/settings"
import AttendanceSummaryTab from "pages/employee-profile/components/attendanceSummaryTab";
import YoloManagement from "pages/yolo-management";
import CompanyManagement from "pages/companyManagement";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Admin-only routes */}
          <Route
            path="/admin-dashboard"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <EmployeeManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <AdminManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <Settings />
              </ProtectedRoute>
            }
          />
          {/* <Route
            path="/camera-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <CameraManagement />
              </ProtectedRoute>
            }
          /> */}
          <Route
            path="/department"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <DepartmentManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/role-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <RoleManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stranger-detection"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <StrangerDetection />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leave-settings"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <LeaveSettings />
              </ProtectedRoute>
            }
          />

          {/* Employee-only routes */}
          <Route
            path="/employee-dashboard"
            element={
              <ProtectedRoute allowedRoles={["employee"]}>
                <EmployeeDashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-profile"
            element={
              <ProtectedRoute allowedRoles={["employee"]}>
                <EmployeeProfile />
              </ProtectedRoute>
            }
          />
          <Route
            path="/employee-attendance-records"
            element={
              <ProtectedRoute allowedRoles={["employee"]}>
                <AttendanceSummaryTab />
              </ProtectedRoute>
            }
          />

          {/* Both Admin & Employee */}
          <Route
            path="/attendance-records"
            element={
              <ProtectedRoute allowedRoles={["admin", "employee"]}>
                <AttendanceRecords />
              </ProtectedRoute>
            }
          />
          <Route
            path="/leave-management"
            element={
              <ProtectedRoute allowedRoles={["admin", "employee"]}>
                <LeaveManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/company"
            element={
              <ProtectedRoute allowedRoles={["admin", "super_admin"]}>
                <CompanyManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/salary-management"
            element={
              <ProtectedRoute allowedRoles={["admin", "employee"]}>
                <SalaryManagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/camera-management"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <SettingsMnagement />
              </ProtectedRoute>
            }
          />
          <Route
            path="/yolo-settings"
            element={
              <ProtectedRoute allowedRoles={["admin"]}>
                <YoloManagement />
              </ProtectedRoute>
            }
          />

          {/* Default */}
          <Route path="/" element={<LoginPage />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
        <Toaster position="top-right" reverseOrder={false} />
      </ErrorBoundary>

    </BrowserRouter>
  );
};

export default Routes;
